"use client"
import Image from "next/image";
import Link from "next/link";
import React from "react";
import "./VacancyManager.scss";
import {toggleSendCVModal} from "@/helpers/toggleModals";
const VacancyManager = ({ hr }) => {
  return (
    <section className="mobile-none manager">
      <div className="section__wrapper">
        <div className="vacancy__container manager-flex">
          <Link href={hr.link} className="manager__link">
            <div className="manager__info">
              <Image
                  src={hr.photo}
                  width={40}
                  height={40}
                  className="manager__img"
                  alt={hr.name}
              />
              <div>
                <p className="manager__name">{hr.name}</p>
                <p className="manager__position">{hr.position}</p>
              </div>
            </div>
            <Image
                src={"/images/manager-linkedin.svg"}
                width={20}
                height={20}
                className="manager__logo"
                alt={"linked in"}
            />
          </Link>
          <button onClick={toggleSendCVModal} className="button">Apply now</button>
        </div>
      </div>
    </section>
  );
};

export default VacancyManager;
